import isNativeApp from "../../../utils/isNativeApp";

export default function useScreenshot() {
  const takeScreenshot = async (element) => {
    if (isNativeApp()) {
      try {
        const { Screenshot } = await import(/* webpackIgnore: true */ "@capacitor/screenshot");
        const result = await Screenshot.take();
        return "data:image/png;base64," + result.base64;
      } catch (_) {
        return null;
      }
    } else {
      try {
        const { default: html2canvas } = await import("html2canvas");
        const passwords = document.querySelectorAll("input[type=password]");
        passwords.forEach((el) => {
          el.dataset._blurBak = el.style.filter || "";
          el.style.filter = "blur(8px)";
        });
        const target = element || document.body;
        const canvas = await html2canvas(target, { scale: 1 });
        passwords.forEach((el) => {
          el.style.filter = el.dataset._blurBak || "";
          delete el.dataset._blurBak;
        });
        return canvas.toDataURL();
      } catch (_) {
        return null;
      }
    }
  };

  return { takeScreenshot };
}
